/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Republish_CheckInputs */

const vi_einvoice_republish_check = /** @type {(inputs: Einvoice_Republish_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tôi đã kiểm tra trên web MISA: đơn này chưa được xuất tay`)
};

/**

* @param {Einvoice_Republish_CheckInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_republish_check = /** @type {((inputs?: Einvoice_Republish_CheckInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Republish_CheckInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_republish_check(inputs)
});